module.exports = __webpack_public_path__ + "static/media/velocity-result-poster.34e150f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/screens/highDefinitionOptics/VelocityTest/velocity-result-poster.jpg
// module id = 3619
// module chunks = 0